import DOMPurify from 'dompurify'

// Rich text written by merchants (product descriptions, channel texts) shown in the POS, where Johku staff are
// signed in too: formatting stays, scripts, event handlers and non-web links go
export default function sanitizeHtml (html) {
  if (!html || typeof window === 'undefined') {
    return ''
  }
  return DOMPurify.sanitize(String(html), {
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'object', 'embed',
      'iframe', 'frame', 'frameset', 'base', 'link', 'meta'],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/(?!\/))/i
  })
}
